import { createAsyncThunk } from '@reduxjs/toolkit';

import { changeRound } from './change-round';
import { aflApi } from '../../api/afl-api';

export const changeSeason = createAsyncThunk(
    'statspro/changeSeason',
    async (options = {}, { dispatch }) => {
        const { slice, season, round, removeFinals } = options;

        dispatch({
            type: `statspro/${slice}/setNavItem`,
            payload: { navItem: 'season', value: season }
        });

        // Fetch rounds
        const { data: rounds } = await dispatch(
            aflApi.endpoints.getRounds.initiate({
                compseasonId: season.id,
                params: { pageSize: 50 }
            })
        );

        // Set 'rounds' nav item in the state
        dispatch({
            type: `statspro/${slice}/setNavItem`,
            payload: { navItem: 'rounds', value: rounds }
        });

        const roundsToFind = removeFinals
            ? rounds.filter(PULSE.app.common.match.isNonFinalRound)
            : rounds;

        let selectedRound;

        // If whole season
        if (round.id === -1) {
            selectedRound = {
                id: -1,
                initialItemId: -1,
                number: 0
            };
        } else {
            selectedRound =
                roundsToFind.find((item) =>
                    round
                        ? item.id === parseInt(round.id)
                        : item.roundNumber === season.currentRoundNumber
                ) ?? roundsToFind[removeFinals ? roundsToFind.length - 1 : 0];
        }

        // Set selected round
        await dispatch(
            changeRound({
                slice,
                round: selectedRound,
                season
            })
        );
    }
);
